import { useState } from 'react';

import Button from '@/components/Common/Button';
import {
  DialogHeader,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  Dialog,
} from '@/components/ui/Dialog';
import ButtonGroup from '@/components/Common/ButtonGroup';
import { OfferLinkResponse, useUpdateOfferLink } from '@/hooks/api/offerLinks';
import { ExperimentResponse } from '@/hooks/api/experiments';
import { LinkIcon } from 'lucide-react';
import OfferLinkForm from './OfferLinkForm';

type UpdateOfferLinkProps = {
  offerLink: OfferLinkResponse;
  experiment: ExperimentResponse;
  onSuccess?: (offerLink: OfferLinkResponse) => void;
};

const UpdateOfferLink = ({
  offerLink,
  experiment,
  onSuccess,
}: UpdateOfferLinkProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [, updateOfferLink] = useUpdateOfferLink(offerLink.id);

  return (
    <Dialog onOpenChange={setIsDialogOpen} open={isDialogOpen}>
      <DialogTrigger asChild>
        <ButtonGroup>
          <Button
            size="small"
            onClick={() => setIsDialogOpen(true)}
            icon={<LinkIcon size="1em" />}
          >
            Continue linking offer
          </Button>
        </ButtonGroup>
      </DialogTrigger>
      <DialogContent className="max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Link existing offer</DialogTitle>
        </DialogHeader>
        <div className="min-h-[270px]">
          <OfferLinkForm
            experiment={experiment}
            defaultValues={offerLink.attributes}
            saveOfferLink={updateOfferLink}
            onSuccess={(values) => {
              onSuccess?.(values);
              setIsDialogOpen(false);
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateOfferLink;
